/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-01 11:10:07
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-15 13:29:48
 * @FilePath: /zeelool-nextjs/src/components/Layout/Footer/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { EPlatform } from '@/utils/enums/platform-enum';
import { checkFooterConfig } from '@/utils/tools';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { FC, useEffect, useMemo, useRef } from 'react';
const FooterMobile = dynamic(() => import('./Footer.m'), { ssr: true });
const FooterPC = dynamic(() => import('./Footer.pc'), { ssr: true });

interface FooterProps {
  navList: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
  isShowFooterNavFromServer: boolean;
  isShowFooterSubscribeFromServer: boolean;
  deviceType: EPlatform;
}

const Footer: FC<FooterProps> = ({
  navList,
  isShowFooterNavFromServer,
  isShowFooterSubscribeFromServer,
  deviceType,
}) => {
  const { trackEvent } = useReporting();
  const setIsShowFooter = useStore((state) => state.setIsShowFooterNav);
  const setIsShowFooterSubscribe = useStore((state) => state.setIsShowFooterSubscribe);
  const isShowSubscribe = useStore((state) => state.isShowFooterSubscribe);
  const isShowFooter = useStore((state) => state.isShowFooterNav);
  const isClientInit = useRef(false);
  const path = usePathname();
  const isMobile = deviceType !== EPlatform.WEB;
  const { cnName } = useRouteMetadata();

  useEffect(() => {
    isClientInit.current = true;
  }, []);

  const finalIsShowFooterNav = useMemo(() => {
    if (isClientInit.current) {
      return isShowFooter;
    }
    return isShowFooterNavFromServer;
  }, [isShowFooter, isShowFooterNavFromServer]);

  const finalIsShowFooterSubscribe = useMemo(() => {
    if (isClientInit.current) {
      return isShowSubscribe;
    }
    return isShowFooterSubscribeFromServer;
  }, [isShowSubscribe, isShowFooterSubscribeFromServer]);

  const SDSocialMediaClick = (btn: string) => {
    trackEvent(
      {
        eventName: 'Socialmedia_Click',
        properties: {
          btn_name: btn,
          page_name: cnName,
          url_path: window.location.href,
        },
      },
      [ProviderType.SENSORS],
    );
  };

  const SDBottomNavTabClick = (
    first_tab_name: string,
    second_tab_name?: string,
    first_tab_index?: number,
    second_tab_index?: number,
  ) => {
    trackEvent(
      {
        eventName: 'BottomNavTab_Click',
        properties: {
          first_tab_name,
          second_tab_name,
          first_tab_index,
          second_tab_index,
          page_name: cnName,
          url_path: window.location.href,
        },
      },
      [ProviderType.SENSORS],
    );
  };

  useEffect(() => {
    const { isShowFooterNav, isShowFooterSubscribe } = checkFooterConfig(path, isMobile);
    setIsShowFooter(isShowFooterNav);
    setIsShowFooterSubscribe(isShowFooterSubscribe);
  }, [path]);

  return finalIsShowFooterNav ? (
    <>
      <WebOnly>
        <FooterPC
          navList={navList}
          SDSocialMediaClick={SDSocialMediaClick}
          SDBottomNavTabClick={SDBottomNavTabClick}
          isShowSubscribe={finalIsShowFooterSubscribe}
          deviceType={deviceType}
        />
      </WebOnly>
      <WapOnly hideApp>
        <FooterMobile
          navList={navList}
          SDSocialMediaClick={SDSocialMediaClick}
          SDBottomNavTabClick={SDBottomNavTabClick}
          isShowSubscribe={finalIsShowFooterSubscribe}
          deviceType={deviceType}
        />
      </WapOnly>
    </>
  ) : null;
};

export default Footer;
